module.exports = __webpack_public_path__ + "img/right.4ea836c5.png";